import { memo } from 'react'

interface IPaymentIconProps {
  className?: string
}

const CreditCardIcon: React.FC<IPaymentIconProps> = memo(
  ({ className = '' }) => (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M24 4.7999V19.1999C24 19.8599 23.765 20.4249 23.295 20.8949C22.825 21.3649 22.26 21.5999 21.6 21.5999H2.4C1.74 21.5999 1.175 21.3649 0.705 20.8949C0.235 20.4249 0 19.8599 0 19.1999V4.7999C0 4.1399 0.235 3.5749 0.705 3.1049C1.175 2.6349 1.74 2.3999 2.4 2.3999H21.6C22.26 2.3999 22.825 2.6349 23.295 3.1049C23.765 3.5749 24 4.1399 24 4.7999ZM2.4 7.1999H21.6V4.7999H2.4V7.1999ZM2.4 11.9999V19.1999H21.6V11.9999H2.4Z"
        fill="white"
      />
    </svg>
  ),
)

export { CreditCardIcon }
